/**
 * The settings that differ between environments, each with the .env variable it comes from in development.
 *
 * They aren't built into the app, so that one build can be deployed to Staging and then promoted to Production.
 * index.html loads /config.js, which sets them on window.__DD_CONFIG__ for src/config.ts to read. The dev server makes
 * config.js from the .env files. The build writes it with each setting's Octopus variable instead of a value, which is
 * Ui. and the setting's name capitalized (apiUrl's is Ui.ApiUrl), and Octopus fills those in when it deploys.
 */
export const runtimeConfigKeys = {
  serverSideAppUrl: 'VITE_SERVER_SIDE_APP_URL',
  apiUrl: 'VITE_API_URL',
  defaultOutgoingFromAddress: 'VITE_DEFAULT_OUTGOING_FROM_ADDRESS',
  gtmId: 'VITE_GTM_ID',
  googleApiDevKey: 'VITE_GOOGLE_API_DEV_KEY',
  googleApiClientId: 'VITE_GOOGLE_API_CLIENT_ID',
  googleAppId: 'VITE_GOOGLE_APP_ID',
  pusherApiKey: 'VITE_PUSHER_API_KEY',
  nylasClientId: 'VITE_NYLAS_CLIENT_ID',
} as const

export type RuntimeConfig = Record<keyof typeof runtimeConfigKeys, string>
